const cards = [
  {
    title: '《我独自升级》完结篇全解析',
    desc: '从E级猎人到暗影君主，回顾这部韩漫天花板级作品的完整剧情脉络与经典战斗场面。',
    tag: '深度解析',
    img: 'https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20warrior%20with%20shadow%20army%20in%20dramatic%20pose%2C%20warm%20orange%20and%20purple%20contrast%20lighting%2C%20anime%20art%20style%2C%20dynamic%20composition%2C%20clean%20background%2C%20manga%20illustration&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '2024最值得期待的韩漫新作',
    desc: '盘点今年韩漫市场即将上线的优质新作，从奇幻到恋爱题材全覆盖。',
    tag: '新作推荐',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20vibrant%20illustration%20of%20various%20romance%20and%20fantasy%20characters%2C%20Korean%20webtoon%20style%2C%20warm%20soft%20lighting%2C%20cheerful%20atmosphere%2C%20modern%20digital%20art%2C%20clean%20composition&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '日漫经典回顾：那些年我们追过的神作',
    desc: '重温那些陪伴一代人成长的经典日漫作品，从少年Jump到Magazine的不朽名作。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20manga%20collection%20with%20classic%20Japanese%20comic%20book%20covers%2C%20warm%20vintage%20tones%2C%20soft%20lighting%2C%20cozy%20reading%20atmosphere%2C%20artistic%20arrangement%2C%20clean%20background&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '国漫崛起：不可错过的国产精品',
    desc: '近年来国漫质量突飞猛进，这些优秀国产漫画作品展现了属于中国的独特魅力。',
    tag: '国漫推荐',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20style%20comic%20illustration%20with%20traditional%20elements%20and%20modern%20aesthetics%2C%20warm%20orange%20and%20gold%20tones%2C%20elegant%20composition%2C%20martial%20arts%20theme%2C%20clean%20artistic%20style&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '下拉式阅读 VS 传统翻页：哪种更适合你？',
    desc: '对比两种阅读模式的优劣，帮你找到最适合自己阅读习惯的漫画浏览方式。',
    tag: '使用指南',
    img: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20and%20smartphone%20displaying%20vertical%20scroll%20manga%20reading%2C%20warm%20lighting%2C%20cozy%20environment%2C%20digital%20reading%20comparison%2C%20clean%20minimal%20composition&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '恋爱漫画推荐：甜到掉牙的高分作品',
    desc: '精选评分最高的恋爱甜宠漫画，从校园纯爱到职场恋情，满足你的少女心。',
    tag: '甜宠推荐',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20with%20couple%20characters%2C%20soft%20pink%20and%20warm%20orange%20tones%2C%20dreamy%20atmosphere%2C%20cherry%20blossom%20elements%2C%20clean%20anime%20art%20style%2C%20sweet%20composition&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '悬疑漫画入坑指南：烧脑神作合集',
    desc: '从心理惊悚到本格推理，精选最好看的悬疑推理漫画作品，挑战你的逻辑极限。',
    tag: '悬疑推荐',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20and%20suspenseful%20manga%20illustration%20with%20dark%20alley%20and%20detective%20elements%2C%20warm%20amber%20streetlight%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20clean%20composition&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">编辑团队精心挑选的优质漫画推荐与深度解析，发现你的下一本必读之作</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.slice(0, 7).map((card) => (
            <div
              key={card.title}
              className={`group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer ${
                cards.indexOf(card) === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${cards.indexOf(card) === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}